import { produce } from "immer";
import {
  FETCH_SURVEYS,
  FETCH_SURVEYS_SUCCESS,
  FETCH_SURVEYS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_SURVEY,
  ADD_SURVEY_SUCCESS,
  ADD_SURVEY_FAILURE,
  //
  EDIT_SURVEY,
  EDIT_SURVEY_SUCCESS,
  EDIT_SURVEY_FAILURE,
  //
  DELETE_SURVEY,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  TOGGLE_QUE_MODAL,
  //
  INVITE,
  INVITE_SUCCESS,
  INVITE_FAILURE,
  //
  SET_YEAR,
  SET_DASH_YEAR,
  //
  GENERATE_QR,
  GENERATE_QR_SUCCESS,
  GENERATE_QR_FAILURE,
  //
  FETCH_INVITEES,
  FETCH_INVITEES_SUCCESS,
  FETCH_INVITEES_FAILURE,
  //
  FETCH_RESPONSES,
  FETCH_RESPONSES_SUCCESS,
  FETCH_RESPONSES_FAILURE,
  //
  GET_RESPONSE,
  GET_RESPONSE_SUCCESS,
  GET_RESPONSE_FAILURE,
  //
  GET_DASHBOAD,
  GET_DASHBOAD_SUCCESS,
  GET_DASHBOAD_FAILURE,
  //
  GET_OVERVIEW,
  GET_OVERVIEW_SUCCESS,
  GET_OVERVIEW_FAILURE,
  //
  GET_HEADLINES,
  GET_HEADLINES_SUCCESS,
  GET_HEADLINES_FAILURE,
  //
  GET_JSON,
  GET_JSON_SUCCESS,
  GET_JSON_FAILURE,
  UPDATE_JSON,
  //
  SEARCH_SURVEY,
  SEARCH_SURVEY_SUCCESS,
  SEARCH_SURVEY_FAILURE,
  //
  GET_ACTIONS,
  GET_ACTIONS_SUCCESS,
  GET_ACTIONS_FAILURE,
  //
  TOGGLE_ACTION_MODAL,
  //
  ADD_ACTION,
  ADD_ACTION_SUCCESS,
  ADD_ACTION_FAILURE,
  //
  EDIT_ACTION,
  EDIT_ACTION_SUCCESS,
  EDIT_ACTION_FAILURE,
  //
  DELETE_ACTION,
  DELETE_ACTION_SUCCESS,
  DELETE_ACTION_FAILURE,
  //
  ADD_ITEM,
  ADD_ITEM_SUCCESS,
  ADD_ITEM_FAILURE,
  //
  TOGGLE_ITEM_MODAL,
  TOGGLE_OUTCOME_MODAL,
  //
  ADD_OUTCOME,
  ADD_OUTCOME_SUCCESS,
  ADD_OUTCOME_FAILURE,
  //
  GET_PLAN,
  GET_PLAN_SUCCESS,
  GET_PLAN_FAILURE,
  //
  EDIT_OUTCOME,
  EDIT_OUTCOME_SUCCESS,
  EDIT_OUTCOME_FAILURE,
  //
  TOGGLE_DELETE,
  //
  DELETE_PLAN,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
  //
  EDIT_ITEM,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEM_FAILURE,
  //
  PRINT_PLAN,
  PRINT_PLAN_SUCCESS,
  PRINT_PLAN_FAILURE,
  //
  EXPORT_SURVEY,
  EXPORT_SURVEY_SUCCESS,
  EXPORT_SURVEY_FAILURE,
  //
  TOGGLE_COMMENT,
  TOGGLE_SENTIMENT,
  TOGGLE_INVEMP_MODAL,
  //
  GET_FINDING_REPORT,
  GET_FINDING_REPORT_SUCCESS,
  GET_FINDING_REPORT_FAILURE,
  //
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  //
  FETCH_ANALYTICS,
  FETCH_ANALYTICS_SUCCESS,
  FETCH_ANALYTICS_FAILURE,
  TOGGLE_FINDING_COMMENT,
  //
  UPDATE_SUMMARY,
  UPDATE_SUMMARY_SUCCESS,
  UPDATE_SUMMARY_FAILURE,
  //
  UPDATE_SURVEY_ADD,
  //
  TOGGLE_COPY_MODAL,
  TOGGLE_BROWSE_MODAL,
  TOGGLE_AI_MODAL,
  //
  GENERATE_JSON,
  GENERATE_JSON_SUCCESS,
  GENERATE_JSON_FAILURE,
  //
  GET_TEMPLATES,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAILURE,
  //
  GET_PREDICTION_REPORT,
  GET_PREDICTION_REPORT_SUCCESS,
  GET_PREDICTION_REPORT_FAILURE,
  //
  GET_AI_REPORT,
  GET_AI_REPORT_SUCCESS,
  GET_AI_REPORT_FAILURE,
  //
  FETCH_SURVEY_COMPARISONS,
  FETCH_SURVEY_COMPARISONS_SUCCESS,
  FETCH_SURVEY_COMPARISONS_FAILURE,
  FETCH_COMPARE_CANDIDATES,
  FETCH_COMPARE_CANDIDATES_SUCCESS,
  FETCH_COMPARE_CANDIDATES_FAILURE,
  CREATE_SURVEY_COMPARE,
  CREATE_SURVEY_COMPARE_SUCCESS,
  CREATE_SURVEY_COMPARE_FAILURE,
  SAVE_SURVEY_COMPARE,
  SAVE_SURVEY_COMPARE_SUCCESS,
  SAVE_SURVEY_COMPARE_FAILURE,
  DELETE_SURVEY_COMPARE,
  DELETE_SURVEY_COMPARE_SUCCESS,
  DELETE_SURVEY_COMPARE_FAILURE,
  FETCH_SURVEY_COMPARE,
  FETCH_SURVEY_COMPARE_SUCCESS,
  FETCH_SURVEY_COMPARE_FAILURE,
  CLEAR_SURVEY_COMPARE,
  CREATE_SURVEY_IMPORT,
  CREATE_SURVEY_IMPORT_SUCCESS,
  CREATE_SURVEY_IMPORT_FAILURE,
  FETCH_SURVEY_IMPORT,
  FETCH_SURVEY_IMPORT_SUCCESS,
  FETCH_SURVEY_IMPORT_FAILURE,
  CLEAR_SURVEY_IMPORT,
} from "./constants";

export const initialState = {
  isFetching: false,
  surveyList: [],
  //
  isFetching: false,
  currentSurvey: {},
  //
  isSubmitting: false,
  isDeleting: false,
  //
  inviteModal: {
    open: false,
  },
  queModal: {
    open: false,
  },
  isInviting: false,
  year: new Date().getFullYear(),
  //
  isFetchingInvitees: false,
  inviteList: {},
  //
  isFetchingResponse: false,
  responseList: {},
  //
  currentResponse: {},
  //
  dashboardYear: new Date().getFullYear(),
  dashboardData: {},
  isFetchingDash: false,
  //
  isFetchingOverview: false,
  overviewData: [],
  overviewList: [],
  //
  isFetchingHeadlines: false,
  headlines: [],
  //
  isFetchingJson: false,
  json: [],
  currentJson: [],
  //
  actionList: [],
  isGettingActions: false,
  actionModal: {
    open: false,
  },
  isAddingAction: false,
  isEditingAction: false,
  isDeletingAction: false,
  isAddingItem: false,

  itemModal: { open: false },
  currentItem: {},
  outcomeModal: { open: false },
  isAddingOutcome: false,
  isEditingOutcome: false,
  isGettingPlan: false,
  currentPlan: {},
  deleteModal: {
    open: false,
  },
  isDeletingPlan: false,
  isEditingItem: false,
  isPrinting: false,
  isExportingSurvey: false,
  showComments: true,
  showSentiment: true,
  empInviteModal: false,
  isFetchingTemplates: false,
  surveyTemplates: [],
  isFetchingFinding: false,
  findingReport: [],
  isFetchingAnalytics: false,
  surveyAnalytics: {},
  showFindingComments: true,
  isUpdatingSummary: false,
  surveyAddData: {},
  copyModal: {
    open: false,
  },
  browseModal: {
    open: false,
  },
  aiModal: {
    open: false,
  },
  isGeneratingJson: false,
  generatedJson: [],
  //
  isFetchingTemplates: false,
  templates: {},
  //
  isFetchingAiReport: false,
  aiReport: {},
  //
  isFetchingPredictionReport: false,
  predictionReport: {},
  // comparisons
  isFetchingComparisons: false,
  comparisonList: [],
  isFetchingCompareCandidates: false,
  compareCandidates: [],
  isCreatingCompare: false,
  isSavingCompare: false,
  isDeletingCompare: false,
  isFetchingCompare: false,
  currentComparison: {},
  isCreatingSurveyImport: false,
  isFetchingSurveyImport: false,
  currentSurveyImport: {},
};

const SurveyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_SURVEYS:
        draft.isFetching = true;
        draft.surveyList = [];
        break;
      case FETCH_SURVEYS_SUCCESS:
        draft.isFetching = false;
        draft.surveyList = action.payload;
        break;
      case FETCH_SURVEYS_FAILURE:
        draft.isFetching = false;
        draft.surveyList = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentSurvey = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentSurvey = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentSurvey = {};
        break;
      // Add
      case ADD_SURVEY:
        draft.isSubmitting = true;
        break;
      case ADD_SURVEY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_SURVEY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_SURVEY:
        draft.isSubmitting = true;
        break;
      case EDIT_SURVEY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_SURVEY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_SURVEY:
        draft.isDeleting = true;
        break;
      case DELETE_SURVEY_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_SURVEY_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_INVITE_MODAL:
        draft.inviteModal = action.payload;
        break;
      case TOGGLE_QUE_MODAL:
        draft.queModal = action.payload;
        break;

      //
      case INVITE:
        draft.isInviting = true;
        break;
      case INVITE_SUCCESS:
        draft.isInviting = false;
        break;
      case INVITE_FAILURE:
        draft.isInviting = false;
        break;
      //
      case SET_YEAR:
        draft.year = action.payload;
        break;
      case SET_DASH_YEAR:
        draft.dashboardYear = action.payload;
        break;

      case GENERATE_QR:
        draft.isGenerating = true;
        draft.isGenerated = false;
        draft.qrPDF = null;
        break;
      case GENERATE_QR_SUCCESS:
        draft.isGenerating = false;
        draft.qrPDF = action.payload ?? null;
        draft.isGenerated = true;
        break;
      case GENERATE_QR_FAILURE:
        draft.isGenerating = false;
        draft.qrPDF = null;
        draft.isGenerated = true;
        break;

      //
      case FETCH_INVITEES:
        draft.isFetchingInvitees = true;
        draft.inviteList = {};
        break;
      case FETCH_INVITEES_SUCCESS:
        draft.isFetchingInvitees = false;
        draft.inviteList = action.payload;
        break;
      case FETCH_INVITEES_FAILURE:
        draft.isFetchingInvitees = false;
        draft.inviteList = {};
        break;

      //
      case FETCH_RESPONSES:
        draft.isFetchingResponse = true;
        draft.responseList = {};
        break;
      case FETCH_RESPONSES_SUCCESS:
        draft.isFetchingResponse = false;
        draft.responseList = action.payload;
        break;
      case FETCH_RESPONSES_FAILURE:
        draft.isFetchingResponse = false;
        draft.responseList = {};
        break;

      //
      case GET_RESPONSE:
        draft.currentResponse = {};
        break;
      case GET_RESPONSE_SUCCESS:
        draft.currentResponse = action.payload;
        break;
      case GET_RESPONSE_FAILURE:
        draft.currentResponse = {};
        break;

      //
      case GET_DASHBOAD:
        draft.dashboardData = {};
        draft.isFetchingDash = true;
        break;
      case GET_DASHBOAD_SUCCESS:
        draft.dashboardData = action.payload;
        draft.isFetchingDash = false;
        break;
      case GET_DASHBOAD_FAILURE:
        draft.dashboardData = {};
        draft.isFetchingDash = false;
        break;

      //
      case GET_OVERVIEW:
        draft.isFetchingOverview = true;
        break;
      case GET_OVERVIEW_SUCCESS:
        draft.overviewData = action.payload.raw;
        draft.overviewList = action.payload.list;
        draft.isFetchingOverview = false;
        break;
      case GET_OVERVIEW_FAILURE:
        draft.overviewData = [];
        draft.overviewList = [];
        draft.isFetchingOverview = false;
        break;

      //
      case GET_HEADLINES:
        draft.headlines = [];
        draft.isFetchingHeadlines = true;
        break;
      case GET_HEADLINES_SUCCESS:
        draft.headlines = action.payload;
        draft.isFetchingHeadlines = false;
        break;
      case GET_HEADLINES_FAILURE:
        draft.headlines = [];
        draft.isFetchingHeadlines = false;
        break;

      //
      case GET_JSON:
        draft.json = [];
        draft.isFetchingJson = true;
        break;
      case GET_JSON_SUCCESS:
        draft.json = action.payload;
        draft.isFetchingJson = false;
        break;
      case GET_JSON_FAILURE:
        draft.json = [];
        draft.isFetchingJson = false;
        break;
      case UPDATE_JSON:
        draft.currentJson = action.payload;
        break;

      //
      case SEARCH_SURVEY:
        draft.isSearching = true;
        draft.searchSurveyList = [];
        draft.overviewList = [];
        draft.overviewData = [];
        break;
      case SEARCH_SURVEY_SUCCESS:
        draft.isSearching = false;
        draft.searchSurveyList = action.payload;
        break;
      case SEARCH_SURVEY_FAILURE:
        draft.isSearching = false;
        draft.searchSurveyList = [];
        break;

      //
      case GET_ACTIONS:
        draft.isGettingActions = true;
        draft.actionList = [];
        draft.currentPlan = {};
        break;
      case GET_ACTIONS_SUCCESS:
        draft.isGettingActions = false;
        draft.actionList = action.payload;
        break;
      case GET_ACTIONS_FAILURE:
        draft.isGettingActions = false;
        draft.actionList = [];
        draft.currentPlan = {};
        break;

      //
      case TOGGLE_ACTION_MODAL:
        draft.actionModal = action.payload;
        break;

      //
      case ADD_ACTION:
        draft.isAddingAction = true;
        break;
      case ADD_ACTION_SUCCESS:
        draft.isAddingAction = false;
        break;
      case ADD_ACTION_FAILURE:
        draft.isAddingAction = false;
        break;

      //
      case EDIT_ACTION:
        draft.isEditingAction = true;
        break;
      case EDIT_ACTION_SUCCESS:
        draft.isEditingAction = false;
        break;
      case EDIT_ACTION_FAILURE:
        draft.isEditingAction = false;
        break;

      case DELETE_ACTION:
        draft.isDeletingAction = true;
        break;
      case DELETE_ACTION_SUCCESS:
        draft.isDeletingAction = false;
        break;
      case DELETE_ACTION_FAILURE:
        draft.isDeletingAction = false;
        break;

      case ADD_ITEM:
        draft.isAddingItem = true;
        break;
      case ADD_ITEM_SUCCESS:
        draft.isAddingItem = false;
        break;
      case ADD_ITEM_FAILURE:
        draft.isAddingItem = false;
        break;

      case TOGGLE_ITEM_MODAL:
        draft.itemModal = action.payload;
        break;

      case TOGGLE_OUTCOME_MODAL:
        draft.outcomeModal = action.payload;
        break;

      case ADD_OUTCOME:
        draft.isAddingOutcome = true;
        break;
      case ADD_OUTCOME_SUCCESS:
        draft.isAddingOutcome = false;
        break;
      case ADD_OUTCOME_FAILURE:
        draft.isAddingOutcome = false;
        break;

      case EDIT_OUTCOME:
        draft.isEditingOutcome = true;
        break;
      case EDIT_OUTCOME_SUCCESS:
        draft.isEditingOutcome = false;
        break;
      case EDIT_OUTCOME_FAILURE:
        draft.isEditingOutcome = false;
        break;

      case GET_PLAN:
        draft.isGettingPlan = true;
        draft.currentPlan = {};
        break;
      case GET_PLAN_SUCCESS:
        draft.isGettingPlan = false;
        draft.currentPlan = action.payload;
        break;
      case GET_PLAN_FAILURE:
        draft.isGettingPlan = false;
        draft.currentPlan = {};
        break;

      case TOGGLE_DELETE:
        draft.deleteModal = action.payload;
        break;

      case DELETE_PLAN:
        draft.isDeletingPlan = true;
        break;
      case DELETE_PLAN_SUCCESS:
        draft.isDeletingPlan = false;
        break;
      case DELETE_PLAN_FAILURE:
        draft.isDeletingPlan = false;
        break;

      case EDIT_ITEM:
        draft.isEditingItem = true;
        break;
      case EDIT_ITEM_SUCCESS:
        draft.isEditingItem = false;
        break;
      case EDIT_ITEM_FAILURE:
        draft.isEditingItem = false;
        break;

      case PRINT_PLAN:
        draft.isPrinting = true;
        break;
      case PRINT_PLAN_SUCCESS:
        draft.isPrinting = false;
        break;
      case PRINT_PLAN_FAILURE:
        draft.isPrinting = false;
        break;

      case EXPORT_SURVEY:
        draft.isExportingSurvey = true;
        break;
      case EXPORT_SURVEY_SUCCESS:
        draft.isExportingSurvey = false;
        break;
      case EXPORT_SURVEY_FAILURE:
        draft.isExportingSurvey = false;
        break;

      case TOGGLE_COMMENT:
        draft.showComments = action.payload;
        break;

      case TOGGLE_FINDING_COMMENT:
        draft.showFindingComments = action.payload;
        break;

      case TOGGLE_SENTIMENT:
        draft.showSentiment = action.payload;
        break;

      case TOGGLE_INVEMP_MODAL:
        draft.empInviteModal = action.payload;
        break;

      case GET_FINDING_REPORT:
        draft.isFetchingFinding = true;
        draft.findingReport = [];
        break;
      case GET_FINDING_REPORT_SUCCESS:
        draft.isFetchingFinding = false;
        draft.findingReport = action.payload;
        break;
      case GET_FINDING_REPORT_FAILURE:
        draft.isFetchingFinding = false;
        draft.findingReport = [];
        break;

      case FETCH_TEMPLATES:
        draft.isFetchingTemplates = true;
        draft.surveyTemplates = [];
        break;
      case FETCH_TEMPLATES_SUCCESS:
        draft.isFetchingTemplates = false;
        draft.surveyTemplates = action.payload;
        break;
      case FETCH_TEMPLATES_FAILURE:
        draft.isFetchingTemplates = false;
        draft.surveyTemplates = [];
        break;

      case FETCH_ANALYTICS:
        draft.isFetchingAnalytics = true;
        draft.surveyAnalytics = {};
        break;
      case FETCH_ANALYTICS_SUCCESS:
        draft.isFetchingAnalytics = false;
        draft.surveyAnalytics = action.payload;
        break;
      case FETCH_ANALYTICS_FAILURE:
        draft.isFetchingAnalytics = false;
        draft.surveyAnalytics = {};
        break;

      case UPDATE_SUMMARY:
        draft.isUpdatingSummary = true;
        break;
      case UPDATE_SUMMARY_SUCCESS:
        draft.isUpdatingSummary = false;
        break;
      case UPDATE_SUMMARY_FAILURE:
        draft.isUpdatingSummary = false;
        break;

      case UPDATE_SURVEY_ADD:
        draft.surveyAddData = action.payload;
        break;

      case TOGGLE_COPY_MODAL:
        draft.copyModal = action.payload;
        break;

      case TOGGLE_BROWSE_MODAL:
        draft.browseModal = action.payload;
        break;

      case TOGGLE_AI_MODAL:
        draft.aiModal = action.payload;
        break;

      case GENERATE_JSON:
        draft.isGeneratingJson = true;
        break;
      case GENERATE_JSON_SUCCESS:
        draft.isGeneratingJson = false;
        draft.generatedJson = action.payload;
        break;
      case GENERATE_JSON_FAILURE:
        draft.isGeneratingJson = false;
        draft.generatedJson = [];
        break;

      case GET_TEMPLATES:
        draft.isFetchingTemplates = true;
        draft.templates = {};
        break;
      case GET_TEMPLATES_SUCCESS:
        draft.isFetchingTemplates = false;
        draft.templates = action.payload;
        break;
      case GET_TEMPLATES_FAILURE:
        draft.isFetchingTemplates = false;
        draft.templates = {};
        break;

      case GET_PREDICTION_REPORT:
        draft.isFetchingPredictionReport = true;
        draft.predictionReport = {};
        break;
      case GET_PREDICTION_REPORT_SUCCESS:
        draft.isFetchingPredictionReport = false;
        draft.predictionReport = action.payload;
        break;
      case GET_PREDICTION_REPORT_FAILURE:
        draft.isFetchingPredictionReport = false;
        draft.predictionReport = {};
        break;

      case GET_AI_REPORT:
        draft.isFetchingAiReport = true;
        draft.aiReport = {};
        break;
      case GET_AI_REPORT_SUCCESS:
        draft.isFetchingAiReport = false;
        draft.aiReport = action.payload;
        break;
      case GET_AI_REPORT_FAILURE:
        draft.isFetchingAiReport = false;
        draft.aiReport = {};
        break;

      case FETCH_SURVEY_COMPARISONS:
        draft.isFetchingComparisons = true;
        break;
      case FETCH_SURVEY_COMPARISONS_SUCCESS:
        draft.isFetchingComparisons = false;
        draft.comparisonList = action.payload || [];
        break;
      case FETCH_SURVEY_COMPARISONS_FAILURE:
        draft.isFetchingComparisons = false;
        draft.comparisonList = [];
        break;

      case FETCH_COMPARE_CANDIDATES:
        draft.isFetchingCompareCandidates = true;
        break;
      case FETCH_COMPARE_CANDIDATES_SUCCESS:
        draft.isFetchingCompareCandidates = false;
        draft.compareCandidates = action.payload || [];
        break;
      case FETCH_COMPARE_CANDIDATES_FAILURE:
        draft.isFetchingCompareCandidates = false;
        draft.compareCandidates = [];
        break;

      case CREATE_SURVEY_COMPARE:
        draft.isCreatingCompare = true;
        break;
      case CREATE_SURVEY_COMPARE_SUCCESS:
        draft.isCreatingCompare = false;
        draft.currentComparison = action.payload || {};
        break;
      case CREATE_SURVEY_COMPARE_FAILURE:
        draft.isCreatingCompare = false;
        break;

      case SAVE_SURVEY_COMPARE:
        draft.isSavingCompare = true;
        break;
      case SAVE_SURVEY_COMPARE_SUCCESS:
        draft.isSavingCompare = false;
        draft.currentComparison = action.payload || {};
        break;
      case SAVE_SURVEY_COMPARE_FAILURE:
        draft.isSavingCompare = false;
        break;

      case DELETE_SURVEY_COMPARE:
        draft.isDeletingCompare = true;
        break;
      case DELETE_SURVEY_COMPARE_SUCCESS:
      case DELETE_SURVEY_COMPARE_FAILURE:
        draft.isDeletingCompare = false;
        break;

      case FETCH_SURVEY_COMPARE:
        draft.isFetchingCompare = true;
        draft.currentComparison = {};
        break;
      case FETCH_SURVEY_COMPARE_SUCCESS:
        draft.isFetchingCompare = false;
        draft.currentComparison = action.payload || {};
        break;
      case FETCH_SURVEY_COMPARE_FAILURE:
        draft.isFetchingCompare = false;
        draft.currentComparison = {};
        break;

      case CLEAR_SURVEY_COMPARE:
        draft.currentComparison = {};
        draft.compareCandidates = [];
        break;

      case CREATE_SURVEY_IMPORT:
        draft.isCreatingSurveyImport = true;
        break;
      case CREATE_SURVEY_IMPORT_SUCCESS:
        draft.isCreatingSurveyImport = false;
        draft.currentSurveyImport = action.payload || {};
        break;
      case CREATE_SURVEY_IMPORT_FAILURE:
        draft.isCreatingSurveyImport = false;
        break;

      case FETCH_SURVEY_IMPORT:
        draft.isFetchingSurveyImport = true;
        break;
      case FETCH_SURVEY_IMPORT_SUCCESS:
        draft.isFetchingSurveyImport = false;
        draft.currentSurveyImport = action.payload || {};
        break;
      case FETCH_SURVEY_IMPORT_FAILURE:
        draft.isFetchingSurveyImport = false;
        break;

      case CLEAR_SURVEY_IMPORT:
        draft.currentSurveyImport = {};
        break;

      default:
        return state;
    }
  });

export default SurveyReducer;
